import { AudioLines } from 'lucide-react'
import { Seo } from '@/components/seo'
import { PageLayout } from '@/components/layout/page-layout'
import { ToolPageLayout } from '@/components/tools/tool-page-layout'
import { AudioPanel } from '@/features/audio/audio-panel'
import { useI18n } from '@/lib/i18n'

export default function AudioConverterPage() {
  const { t } = useI18n()

  return (
    <PageLayout>
      <Seo
        title={t('seoAudioTitle')}
        description={t('seoAudioDesc')}
        keywords={t('seoAudioKw').split(',').map((item) => item.trim())}
      />
      <ToolPageLayout
        icon={AudioLines}
        title={t('toolPageAudio')}
        description={t('toolPageAudioDesc')}
        formats={['MP3', 'WAV', 'AAC', 'M4A']}
      >
        <AudioPanel />
      </ToolPageLayout>
    </PageLayout>
  )
}